module.exports = __webpack_public_path__ + "img/cart.594b15fb.svg";